<template>
  <v-container>
    <app-city-header :payload="payload"> </app-city-header>

    <v-row align="center">
      <v-col sm="3">
        <v-text-field
          label="Nome do acompanhamento"
          name="nome"
          type="text"
          required
          v-model="payload.nome"
          disabled
        ></v-text-field>
      </v-col>

      <v-col sm="2">
        Criado em {{ payload.criacao | moment("DD/MM/YYYY") }}
      </v-col>

      <v-col sm="2" offset-sm="5" class="text-right">
        <v-btn
          v-if="
            !payload.finalizado &&
            !payload.diagnostico &&
            (isAdmin || payload.usuarioId === user.usuarioId) &&
            (isFullAdmin ||
              (config.finalizarAcompanhamento &&
                groupsConfig.finalizarAcompanhamento))
          "
          outlined
          color="primary"
          class="ml-3"
          @click="finalizarAcompanhamento()"
        >
          <span>Finalizar</span>
        </v-btn>
        <br />
        <v-btn
          v-if="
            isAdmin ||
            isConsultorCondutorMunicipio ||
            isConsultorEspecialistaMunicipio ||
            isAnalista
          "
          outlined
          color="primary"
          class="ml-3"
          @click="createPDF"
        >
          <span>Download PDF</span>
        </v-btn>
      </v-col>
    </v-row>

    <div style="padding: 10px">
      <h6>Filtros</h6>
      <v-select
        v-model="search"
        :items="payload.perguntas.map((item) => item.pergunta.tema.nome)"
        chips
        label="Eixos"
        item-text="nome"
        multiple
        :return-object="true"
        clearable
      >
        <template slot="no-data"> Nenhum Eixo </template>
      </v-select>
    </div>

    <div v-for="(filtered, index) in filteredItems" :key="index" ref="pmdTable">
      <div class="category">{{ filtered.name }}</div>
      <v-data-table
        :headers="headers"
        :items="filtered.children"
        class="elevation-1"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:item.pergunta="{ item }">
          <v-row>
            <v-col>
              <b>{{ item.pergunta.numero }}</b> - {{ item.pergunta.texto }}
            </v-col>
          </v-row>
          <v-row v-if="item.pergunta.pontos_especificos">
            <v-col>
              <b>Pontos: </b>
              <v-text-field
                label="Pontos"
                name="pontos"
                type="text"
                v-model="item.pontos_especificos"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="item.pergunta.evidencia">
            <v-col>
              <b>Evidência válida: </b> <i> {{ item.pergunta.evidencia }}</i>
            </v-col>
          </v-row>

          <v-row
            v-if="
              item.pergunta.possuiComentario &&
              !payload.finalizado &&
              !payload.diagnostico &&
              payload.usuarioId === user.usuarioId
            "
          >
            <v-col>
              <v-textarea
                label="Comentário"
                name="Comentário"
                type="text"
                :maxlength="1000"
                solo
                hide-details
                no-resize
                v-model="item.comentario"
                @input="addComentarioPergunta(item)"
              >
              </v-textarea>
              <div style="text-align: end">
                {{ item.comentario ? item.comentario.length : 0 }}/1000
                caracteres
              </div>
            </v-col>
          </v-row>
          <v-row v-if="item.comentario">
            <v-col> <b>Comentário</b>: {{ item.comentario }}</v-col>
          </v-row>
          <!-- <v-row>
            <v-col md="4" sm="4" lg="4">
              <v-card color="secondary" class="text-center">
                {{ item.pergunta.tema.nome }}
              </v-card>
            </v-col>
          </v-row> -->
        </template>

        <template v-slot:item.sim="{ item }">
          <span>
            <v-avatar
              v-bind:class="{
                success: item.resposta === true || item.resposta === 'SIM',
                accent: item.resposta === false || item.resposta === 'NÃO',
              }"
            >
              <v-icon color="white" @click="responderPergunta(item, true)">
                mdi-thumb-up-outline
              </v-icon>
            </v-avatar>
          </span>
        </template>

        <template v-slot:item.nao="{ item }">
          <span>
            <v-avatar
              v-bind:class="{
                error: item.resposta === false || item.resposta === 'NÃO',
                accent: item.resposta === true || item.resposta === 'SIM',
              }"
              style="margin-top: 20px; margin-bottom: 20px"
            >
              <v-icon color="white" @click="responderPergunta(item, false)">
                mdi-thumb-down-outline
              </v-icon>
            </v-avatar>
          </span>
        </template>
        <template slot="no-data">
          <span> Nenhuma pergunta retornada </span>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { attendanceAPI } from "@/modules/attendance";
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { cityAPI } from "../../city/API/CityAPI";
import {
  statusRelacionamentoEnum,
  statusContratoEnum,
  statusRelacionamentoSeloEnum,
} from "@/types";
import { convertImgToBase64 } from "@/helpers/convertImgToBase64";

export default {
  components: {
    AppCityHeader,
  },
  data() {
    return {
      headers: [
        { text: "Pergunta", value: "pergunta" },
        { text: "Sim", value: "sim" },
        { text: "Não", value: "nao" },
      ],
      payload: {
        criacao: "",
        municipioId: 1,
        perguntas: [],
      },
      estado: this.$store.state.uf,

      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      search: [],
      municipioTemas: [],
      statusRelacionamentoEnum: statusRelacionamentoEnum,
      statusContratoEnum: statusContratoEnum,
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    loadCity(municipioId, attendance) {
      cityAPI.get(municipioId).then(({ data }) => {
        this.municipioTemas = data.temas;
        this.payload = attendance;
        if (this.getMunicipioNaoVigenteRespondeSoPerguntasNacionais(data)) {
          this.payload.perguntas = attendance.perguntas.filter(
            (perguntas) => perguntas.pergunta.nacional
          );
        }
        this.payload.perguntas = this.payload.perguntas.filter((item) =>
          this.municipioTemas.some(
            (tema) => item.pergunta.temaId === tema.temaId
          )
        );
        if (!this.user.grupo.verTodosEixos) {
          this.payload.perguntas = this.payload.perguntas.filter((item) =>
            this.user.permissoes.some(
              (per) =>
                per.eixoId === item.pergunta.tema.eixoId &&
                per.municipioId === this.payload.municipioId
            )
          );
        }

        this.setLoading(false);
      });
    },
    getAcompanhamento() {
      this.setLoading(true);

      attendanceAPI
        .get(this.$route.params.acompanhamento)
        .then((resp) => {
          this.loadCity(resp.data.municipioId, resp.data);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter acompanhamentos");
        });
    },
    getMunicipioNaoVigenteRespondeSoPerguntasNacionais(municipio) {
      if (this.isFullAdmin) return false;
      if (
        this.config.municipiosNaoVigentesRespondemPerguntasNacionais &&
        this.groupsConfig.municipiosNaoVigentesRespondemPerguntasNacionais &&
        !this.getMunicipioVigente(municipio)
      ) {
        return true;
      }

      return false;
    },
    getMunicipioVigente(municipio) {
      let isVigente = true;
      if (municipio) {
        if (this.$store.state.uf === "RJ") {
          isVigente =
            this.statusContratoEnum.cidadeEmpreendedora ===
              municipio.statusContratoId &&
            !this.isSala &&
            !this.isAT &&
            municipio.statusId === this.statusRelacionamentoEnum.vigente;
        } else {
          isVigente =
            (this.isSala &&
              municipio.statusId ===
                this.statusRelacionamentoSeloEnum.participante) ||
            municipio.statusId === this.statusRelacionamentoEnum.vigente;
        }
      }

      return isVigente;
    },
    responderPergunta(item, resposta) {
      if (
        this.payload.finalizado ||
        this.payload.diagnostico ||
        (item.resposta && !item.respondida && !item.pergunta.recorrente)
      ) {
        return item;
      }

      this.payload.perguntas.forEach((val) => {
        if (val.acompanhamentoPerguntaId == item.acompanhamentoPerguntaId) {
          val.resposta = resposta;
          val.respondida = true;
        }
      });

      item.resposta = resposta;
      item.respondida = true;

      return item;
    },
    addComentarioPergunta(item) {
      this.payload.perguntas.forEach((val) => {
        if (val.acompanhamentoPerguntaId == item.acompanhamentoPerguntaId) {
          val.comentario = item.comentario;
        }
      });
    },
    finalizarAcompanhamento() {
      this.setLoading(true);
      attendanceAPI
        .finalizar(this.payload)
        .then((resp) => {
          this.$router.push("/cidade/" + this.payload.municipioId);
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao finalizar acompanhamento");
        });
    },
    async createPDF() {
      var source = this.payload.perguntas;
      let rows = [];
      let columnHeader = [];

      if (!this.isSala) {
        columnHeader = [
          "Nº",
          "Tema",
          "Pergunta",
          "Pontos",
          "Resposta",
          "Evidência",
        ];
      } else {
        columnHeader = [
          "Nº",
          "Pilar",
          "Pergunta",
          "Pontos",
          "Resposta",
          "Evidência",
        ];
      }

      let pdfName = `Acompanhamento - ${this.payload.municipio.nome} - ${this.payload.municipio.nome}`;

      source.forEach((element) => {
        var temp = [];
        if (element.resposta === true) {
          element.resposta = "SIM";
        }
        if (element.resposta === false) {
          element.resposta = "NÃO";
        }
        temp = [
          element.pergunta.numero,
          element.pergunta.tema.nome,
          element.pergunta.texto,
          element.pergunta.pontos,
          element.resposta,
          element.pergunta.evidencia,
        ];
        rows.push(temp);
      });
      var subTitulo = this.payload.nome;
      var dimensions = {
        width: 0,
        height: 50,
      };
      var titulo = "Acompanhamento Cidade Empreendedora";
      var logoCidade = new Image();
      if (this.isTur) {
        titulo = "Acompanhamento";
      }
      if (this.isSala) {
        subTitulo =
          subTitulo == "Diagnóstico" ? "Acompanhamento Geral" : subTitulo;
        titulo = "Selo Sebrae de Referência em Atendimento";
        logoCidade.src = await convertImgToBase64(
          `https://slide1-images.s3.amazonaws.com/public/logo/logo-selo.png`,
          400,
          500
        );

        dimensions = {
          width: 70,
          height: 70,
        };
      } else {
        logoCidade.src = await convertImgToBase64(this.logos.logo);
      }

      var logoSebrae = new Image();
      logoSebrae.src = await convertImgToBase64(
        "https://slide1-images.s3.amazonaws.com/public/sebrae-logo.png"
      );

      var doc = new JsPDF("l", "pt");
      doc.setFontSize(16).setFont(undefined, "bold");
      doc.text(250, 45, titulo);

      doc.setFontSize(14).setFont(undefined, "normal");
      doc.text(250, 65, subTitulo);

      doc.setFontSize(13).setFont(undefined, "bold");
      doc.text(250, 85, this.payload.municipio.nome);
      doc.addImage(logoSebrae, "PNG", 700, 30, 100, 50);
      if (
        this.isFullAdmin ||
        (this.groupsConfig.visualizarLogo && this.config.visualizarLogo)
      ) {
        doc.addImage(
          logoCidade,
          "PNG",
          40,
          30,
          dimensions.width,
          dimensions.height
        );
        8;
      }
      doc.setFontSize(11).setFont(undefined, "normal");
      doc.autoTable(columnHeader, rows, {
        startY: 120,
        styles: { overflow: "linebreak", cellWidth: "wrap" },
        columnStyles: {
          text: {
            cellWidth: "auto",
          },
          1: {
            cellWidth: "auto",
          },
          2: {
            cellWidth: "auto",
          },
          3: {
            cellWidth: "auto",
          },
          4: {
            cellWidth: "auto",
          },
          5: {
            cellWidth: "auto",
          },
          6: {
            cellWidth: "auto",
          },
        },
      });
      doc.save(pdfName + ".pdf");
    },
  },
  mounted() {
    this.getAcompanhamento();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorEspecialistaMunicipio",
      "isConsultorCondutorMunicipio",
      "isFullAdmin",
      "isSala",
      "isTur",
      "logos",
    ]),
    filteredItems() {
      let groupBy = this.payload.perguntas.map((item) => {
        return {
          ...item,
          temaNome: item.pergunta.tema.nome,
        };
      });

      let key = "temaNome";
      let aux = groupBy.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});

      groupBy = Object.keys(aux).map((key) => {
        return {
          name: key,
          children: aux[key].sort((a, b) => {
            if (a.pergunta.numero < b.pergunta.numero) {
              return -1;
            } else if (a.pergunta.numero > b.pergunta.numero) {
              return 1;
            } else {
              // nothing to split them
              return 0;
            }
          }),
        };
      });

      return groupBy
        .filter((i) => {
          return !this.search.length || this.search.includes(i.name);
        })
        .sort(function (a, b) {
          if (
            a.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
            b.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          ) {
            return -1;
          }
          if (
            a.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
            b.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          ) {
            return 1;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.category {
  position: sticky;
  top: 0;
  background: var(--corPrimaria);
  color: #fff;
  padding: 10px;
  z-index: 2;
  border-top: 1px solid #ffffff4d;
}
</style>
